import { Avatar, Box, Chip, Typography } from "@mui/material";

const ProfileHeader = ({ adminInfo }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
    <Avatar
      sx={{
        width: 100,
        height: 100,
        mr: 3,
        bgcolor: "primary.main",
        fontSize: "2.5rem",
      }}
    >
      {adminInfo.admin_name?.charAt(0) || "A"}
    </Avatar>
    <Box>
      <Typography variant="h4" component="h1" fontWeight="bold">
        {adminInfo.admin_name}
      </Typography>
      <Chip
        label={adminInfo.role}
        color="primary"
        size="medium"
        sx={{ mt: 1, px: 1, fontWeight: 600 }}
      />
    </Box>
  </Box>
);

export default ProfileHeader;
